/**
 * @codegen
 */
export var SerializationProfile;
(function (SerializationProfile) {
    // Order and numbers of the values should be preserved as this enum gets serialized and a change in order
    // can cause n/n-1 issues during deployment.
    SerializationProfile[SerializationProfile["JSONB"] = 0] = "JSONB";
    SerializationProfile[SerializationProfile["JSON"] = 1] = "JSON";
    SerializationProfile[SerializationProfile["JSOND"] = 2] = "JSOND";
    SerializationProfile[SerializationProfile["Disabled"] = 3] = "Disabled";
    SerializationProfile[SerializationProfile["COMPRESSEDJSON"] = 4] = "COMPRESSEDJSON";
    SerializationProfile[SerializationProfile["MESSAGEPACK"] = 5] = "MESSAGEPACK";
    SerializationProfile[SerializationProfile["COMPRESSEDMESSAGEPACK"] = 6] = "COMPRESSEDMESSAGEPACK";
})(SerializationProfile || (SerializationProfile = {}));
//# sourceMappingURL=serialization-profile.js.map